import { Box, Divider, Paper, Typography } from "@mui/material";
import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import InputWithLabel from "../../Components/InputWithLabel";
import CustomButton from "../../Components/CustomButton";
import { axiosAPI, axiosupload } from "../../Axios/Axios";
import {
  errorNotify,
  succesNotify,
  warningNotify,
  useStyles,
} from "../../CommonCode/Commonfunc";
import { useNavigate, useParams } from "react-router-dom";
import Topics from "../../CommonCode/Topics";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { profanityfn,profanitySend } from "../../Profanity/Profanity";
import GrpStatus from "../../CommonCode/GrpStatus";

export default function EditForumModal() {
  const redirect = useNavigate();
  const classes = useStyles();
  const [image, setImage] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [forumName, setForumName] = useState("");
  const [topic, setTopic] = useState("");
  const [statusValue, setStatusvalue] = useState("");
  const [description, setDescription] = useState("");
  const [statusKey, setstatusKey] = useState("");

  const allowedTypes = ["image/jpeg", "image/png", "image/JPG"];
  const maxFileSize = 1 * 1024 * 1024;
  const Labels = useSelector((state) => state.allLabels.labels);

  const { id } = useParams();
  const JobSeekerloginDetailSlice = useSelector(
    (state) => state.getJobseekerProfileData.jobseekerDetails
  );
  const getForumDetails = async () => {
    if (id) {
      const result = await axiosAPI.get(`/forumDetails?forumid=${id}`);
      const { status, data } = result.data;
      setstatusKey(data.statusKey);

      if (status) {
        if (result.data.data.ownerid == JobSeekerloginDetailSlice.userid) {
          setForumName(data?.forumName);
          setImageUrl(data?.frmLogoPath);
          setTopic(data?.topicid);
          setDescription(data?.description);
          setStatusvalue(data?.forumStatus);
        } else {
          redirect(`/myForum`);
        }
      } else {
        redirect(`/myForum`);
      }
    } else {
      redirect(`/myForum`);
    }
  };
  useEffect(() => {
    getForumDetails();
  }, []);

  const tokens = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  };
  const getImage = async (e) => {
    const selectedFile = e.target.files[0];
    setImage(selectedFile);
    const reader = new FileReader();
    reader.onload = (e) => {
      setImageUrl(e.target.result);
    };
    reader.readAsDataURL(selectedFile);

    if (!e.target.files) {
      errorNotify(Labels.uploadImage);
      return;
    } else if (!allowedTypes.includes(e.target.files[0].type)) {
      errorNotify(Labels.invaildFile);
      return;
    } else if (e.target.files[0].size > maxFileSize) {
      errorNotify(Labels.imageValidation);
      return;
    }
  };
  const uploadImagefn = async () => {
    const data = new FormData();
    data.append("logo", image);
    data.append("type", "forum");
    data.append("forumid", id);
    data.append('language',localStorage.getItem("language"))
    const result = await axiosupload.post("/uploadLogo", data, tokens);
    const { message, status } = result.data;
    if (status) {
      setImage("");
      succesNotify(message);
    } else {
      setImage("");
      // errorNotify(message);
    }
  };

  const submitFormprofanity = (e) => {
    const data = {
      "name": forumName,
      "title": topic,
      "description": description,
    };

    let profanityDetected;
    for (const key in data) {
      if (profanitySend(ProfanityList, data[key])) {
        profanityDetected = true;
        break;
      } else {
        profanityDetected = false;
      }
    }

    if (profanityDetected == false) {
      submitForm(e);
    } else {
      warningNotify(Labels.ProfanityLabel);
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();
    if (!forumName) {
      errorNotify(Labels.forumNameValidation);
      return;
    } else if (!topic) {
      errorNotify(Labels.enterTopic);
      return;
    } else if (!description) {
      errorNotify(Labels.enterDescription);
      return;
    } else if (description.length > 1000) {
      errorNotify(Labels.descriptionValidation);
      return;
    } else {
      const postData = {
        forumid: id,
        name: forumName,
        title: topic,
        description: description,
        status: statusValue,
        language:localStorage.getItem("language")
      };
      try {
        uploadImagefn();

        const result = await axiosAPI.post("/editForum", postData);
        const { status, message } = result.data;
        if (status) {
          succesNotify(message);
          setTimeout(() => {
            redirect("/myForum");
          }, 1000);
        } else {
          errorNotify(message);
        }
      } catch (error) {
        //// console.log(error.message);
      }
    }
  };

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0]; // Get the first accepted file
      if (allowedTypes.includes(file.type)) {
        // Check if file type is allowed
        setImage(file); // Set the uploaded file object
        setImageUrl(URL.createObjectURL(file)); // Set the image URL
      } else {
        // Notify user of invalid file type
        errorNotify(Labels.invaildFile);
      }
    },
    [allowedTypes]
  );

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const dropzoneStyles = {
    border: "2px dashed #cccccc",
    borderRadius: "4px",
    padding: "20px",
    textAlign: "center",
    cursor: "pointer",
  };
  const ProfanityList = useSelector((state) => state.Profanity.wordlist);

  return (
    <Paper elevation={0} sx={{ my: 1 }}>
      <Typography variant="h6" sx={{ color: "#005F8E", p: 2 }}>
        {Labels?.EditForum}
      </Typography>
      <Divider />
      <Box sx={{ p: 2 }}>
        <Typography variant="subtitle1">{Labels.Logo}</Typography>
        <div>
          <div {...getRootProps()} className="dropzone" style={dropzoneStyles}>
            <input {...getInputProps()} />
            <p>{Labels.dragndrop}</p>
          </div>
          {imageUrl && (
            <div>
              <h4>{Labels.UploadedImage}:</h4>
              <img src={imageUrl} alt="Uploaded" width="200px" />
            </div>
          )}
        </div>
        <InputWithLabel
          InputLabel={Labels?.name}
          label={Labels?.name}
          value={forumName}
          style={{ width: "100%" }}
          onChange={(event) =>
            setForumName(profanityfn(ProfanityList, event.target.value))
          }
        />
        <div style={{ margin: "10px 5px" }}>
          <label style={{ color: "#413E3E", width: 230 }}>
            {Labels?.topic}
          </label>
          <Topics
            value={topic}
            label={Labels?.Topics}
            setValue={setTopic}
            style={{
              width: "100%",
              fontSize: "14px",
            }}
          />
        </div>
        <InputWithLabel
          InputLabel={Labels?.description}
          label={Labels?.description}
          value={description}
          multiline
          rows={4}
          style={{ width: "100%" }}
          onChange={(event) =>
            setDescription(profanityfn(ProfanityList, event.target.value))
          }
        />
        <div style={{ margin: "10px 5px" }}>
          <label style={{ color: "#413E3E", width: 230 }}>
            {Labels?.Status}
          </label>
          <GrpStatus
            disabled={statusKey == "Closed"}
            value={statusValue}
            label={Labels?.Status}
            setValue={setStatusvalue}
            style={{
              width: "100%",
              fontSize: "14px",
            }}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "end" }}>
          <CustomButton
            label={Labels?.EditForum}
            style={{ padding: "5px 25px" }}
            onClick={(e) => submitFormprofanity(e)}
          />
        </div>
      </Box>
    </Paper>
  );
}
